
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse/location",
      function () {
        return require("private-next-pages/browse/location.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browse/location"])
      });
    }
  